<script>
export default {
  props: {
    title: { type: String, default: '' },
    text: { type: String, default: '' },
    name: { type: String, default: '' },
    isWidget: { type: Boolean, default: false },
    allowHtml: { type: Boolean },
    whiteMode: { type: Boolean },
  },
  computed: {
    formatIntroText() {
      if (this.text.includes('#name#')) {
        return this.text.replace('#name#', '<h1 class="my-1">' + this.name + '</h1>');
      } else {
        return this.text;
      }
    },
  },
};
</script>

<template>
  <div class="c-primary-header">
    <div v-if="allowHtml" :class="{ 'text-dark': whiteMode }">
      <div id="introText" class="lead c-primary-header-question" v-html="text" :class="{ lead__widget: isWidget }"></div>
    </div>
    <div v-else :class="{ 'text-dark': whiteMode }" class="text-center">
      <h1 v-if="title" class="mb-4 d-none d-sm-block c-primary-header-title">{{ title }}</h1>
      <div class="lead pt-0 c-primary-header-question" :class="{ lead__widget: isWidget }">
        <span id="introText" data-id="introText" v-html="formatIntroText"></span>
      </div>
    </div>
  </div>
</template>
<style>
.lead__widget,
.lead__widget h1 {
  font-size: 20px !important;
  line-height: 24px !important;
  padding-top: 0 !important;
}
/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  h1 {
    font-size: 24px;
  }
  .lead {
    font-size: 16px;
  }
  .lead__widget,
  .lead__widget h1 {
    font-size: 16px !important;
    line-height: 20px !important;
    padding-top: 0 !important;
  }
}
@media (min-width: 600px) and (max-width: 1280px) and (orientation: portrait) {
  .lead {
    font-size: 17px;
    font-weight: 700;
  }
  .lead h1 {
    margin: 0 !important;
    display: inline;
    font-size: 17px;
    font-weight: 700;
  }
}
@media (max-height: 400px) {
  .lead {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-size: 16px;
  }
  .lead h1 {
    margin: 0 !important;
    display: inline;
    font-size: 16px;
  }
}
</style>
